import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {AgencyTable} from './table/AgencyTable'
import {AgencyEditModal} from './agencies-edit-modal/AgencyEditModal'
import {KTCard} from '../../../../_dashboard/helpers'
import {AgencyListHeader} from './header/AgencyListHeader'
import { ToastContainer } from 'react-toastify'

const AgencyList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ToastContainer/>
        <AgencyListHeader />
        <AgencyTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <AgencyEditModal />}
    </>
  )
}

const AgencyListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <AgencyList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {AgencyListWrapper}
